(function () {
  'use strict';

  var DEFAULT_OPENAI_ADS_PIXEL_ID = '6a8f68d941008194a88e2b874d69adfb';
  var config = window.MdnmdOpenAIAdsConfig || {};
  var pixelIds = normalisePixelIds(config.pixelIds || config.pixelIdsText || DEFAULT_OPENAI_ADS_PIXEL_ID);
  if (!pixelIds.length || window.__mdnmdOpenAIAdsInitialized || (window.Shopify && window.Shopify.designMode)) return;
  config.pixelIds = pixelIds;
  window.__mdnmdOpenAIAdsInitialized = true;

  var SUPPORTED_EVENT_TYPES = {
    appointment_scheduled: 'customer_action',
    checkout_started: 'contents',
    contents_viewed: 'contents',
    custom: 'custom',
    items_added: 'contents',
    lead_created: 'customer_action',
    order_created: 'contents',
    page_viewed: 'contents',
    registration_completed: 'customer_action',
    subscription_created: 'plan_enrollment',
    trial_started: 'plan_enrollment'
  };

  var state = {
    consentAllowed: false,
    consentResolved: false,
    pageTracked: false,
    productTracked: false,
    checkoutTracked: false,
    declaredSuccessEventsHandled: false,
    emittedKeys: {},
    currency: config.currency || '',
    cart: {}
  };

  function normalisePixelIds(rawPixelIds) {
    var values = Array.isArray(rawPixelIds) ? rawPixelIds : String(rawPixelIds || '').split(/[\s,]+/);
    return values.map(function (pixelId) {
      return String(pixelId || '').trim();
    }).filter(function (pixelId, index, allPixelIds) {
      return pixelId && allPixelIds.indexOf(pixelId) === index;
    });
  }

  function toInteger(value) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.round(number) : null;
  }

  function itemKey(item) {
    var value = item && (item.variantId || item.variant_id || item.id || item.key);
    return value === undefined || value === null ? '' : String(value);
  }

  function contentId(item) {
    var value = item && (item.sku || item.id || item.variantId || item.variant_id || item.key);
    return value === undefined || value === null ? '' : String(value);
  }

  function unitAmount(item) {
    if (!item) return null;
    var value = item.amount;
    if (value === undefined || value === null) value = item.final_price;
    if (value === undefined || value === null) value = item.price;
    return toInteger(value);
  }

  function itemName(item) {
    if (!item) return '';
    return item.product_title || item.name || item.title || '';
  }

  function quantity(item, fallback) {
    var value = toInteger(item && item.quantity);
    return value !== null && value > 0 ? value : fallback;
  }

  function buildContent(item, itemQuantity) {
    var content = {
      content_type: 'product',
      quantity: itemQuantity
    };
    var id = contentId(item);
    var name = itemName(item);
    var amount = unitAmount(item);
    if (id) content.id = id;
    if (name) content.name = name;
    if (amount !== null) content.amount = amount;
    return content;
  }

  function measure(eventName, data, options, pixelId) {
    if (!state.consentAllowed || typeof window.oaiq !== 'function') return false;
    if (pixelId && pixelIds.indexOf(String(pixelId)) === -1) return false;
    try {
      var args = pixelId
        ? ['measureSingle', String(pixelId), eventName, data]
        : ['measure', eventName, data];
      if (options && Object.keys(options).length) args.push(options);
      window.oaiq.apply(window, args);
      return true;
    } catch (error) {
      // Measurement must never interrupt the storefront experience.
      return false;
    }
  }

  function validOptions(options, eventName) {
    var clean = {};
    options = options || {};
    if (options.event_id) clean.event_id = String(options.event_id);
    if (options.opt_out === true) clean.opt_out = true;
    if (eventName === 'custom' && typeof options.custom_event_name === 'string' &&
      /^[a-z0-9](?:[a-z0-9_-]{0,62}[a-z0-9])?$/.test(options.custom_event_name) &&
      !SUPPORTED_EVENT_TYPES[options.custom_event_name]) {
      clean.custom_event_name = options.custom_event_name;
    }
    return clean;
  }

  function trackEvent(eventName, data, options, pixelId, dedupeKey) {
    var expectedType = SUPPORTED_EVENT_TYPES[eventName];
    if (!expectedType || !data || data.type !== expectedType) return false;
    var cleanOptions = validOptions(options, eventName);
    if (eventName === 'custom' && !cleanOptions.custom_event_name) return false;
    if (dedupeKey && state.emittedKeys[dedupeKey]) return false;
    var sent = measure(eventName, data, cleanOptions, pixelId);
    if (sent && dedupeKey) state.emittedKeys[dedupeKey] = true;
    return sent;
  }

  function trackCustomerAction(eventName, data, options, pixelId, dedupeKey) {
    data = data || {};
    if (!data.type) data.type = 'customer_action';
    return trackEvent(eventName, data, options, pixelId, dedupeKey);
  }

  function trackPlanEnrollment(eventName, data, options, pixelId, dedupeKey) {
    data = data || {};
    if (!data.type) data.type = 'plan_enrollment';
    return trackEvent(eventName, data, options, pixelId, dedupeKey);
  }

  function pageData() {
    var content = { content_type: 'page' };
    if (config.page && config.page.id) content.id = String(config.page.id);
    if (config.page && config.page.name) content.name = String(config.page.name);
    return { type: 'contents', contents: [content] };
  }

  function trackCurrentPage() {
    if (!state.pageTracked) {
      state.pageTracked = true;
      measure('page_viewed', pageData());
    }

    if (!state.productTracked && config.product) {
      state.productTracked = true;
      var data = {
        type: 'contents',
        contents: [buildContent(config.product, 1)]
      };
      var amount = unitAmount(config.product);
      if (amount !== null && state.currency) {
        data.amount = amount;
        data.currency = state.currency;
      }
      measure('contents_viewed', data);
    }
  }

  function setConsent(allowed) {
    allowed = allowed === true;
    var wasAllowed = state.consentAllowed;
    var firstResolution = !state.consentResolved;
    state.consentAllowed = allowed;
    state.consentResolved = true;
    try {
      window.oaiq('consent', allowed);
    } catch (error) {
      return;
    }
    if (allowed && !wasAllowed) trackCurrentPage();
    if (firstResolution) trackDeclaredSuccessEvents();
  }

  function trackDeclaredSuccessEvents() {
    if (state.declaredSuccessEventsHandled) return;
    state.declaredSuccessEventsHandled = true;
    if (!state.consentAllowed || typeof document.querySelectorAll !== 'function') return;
    document.querySelectorAll('[data-openai-ads-success-event]').forEach(function (element) {
      var eventName = element.getAttribute('data-openai-ads-success-event') || '';
      var dataType = element.getAttribute('data-openai-ads-data-type') || '';
      var dedupeKey = element.getAttribute('data-openai-ads-dedupe-key') || eventName;
      trackEvent(eventName, { type: dataType }, null, null, dedupeKey);
    });
  }

  function currentShopifyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      return privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function initialiseConsent() {
    document.addEventListener('visitorConsentCollected', function () {
      setConsent(currentShopifyConsent());
    });

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      setConsent(false);
      return;
    }

    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          setConsent(!error && currentShopifyConsent());
        }
      );
    } catch (error) {
      setConsent(false);
    }
  }

  function snapshotItem(item) {
    return {
      id: contentId(item),
      variantId: itemKey(item),
      name: itemName(item),
      quantity: Math.max(0, quantity(item, 0)),
      amount: unitAmount(item)
    };
  }

  function replaceCartSnapshot(items) {
    var next = {};
    (items || []).forEach(function (item) {
      var key = itemKey(item);
      if (key) next[key] = snapshotItem(item);
    });
    state.cart = next;
  }

  function emitItemsAdded(items) {
    if (!items.length) return;
    var contents = [];
    var total = 0;
    var hasAllAmounts = true;

    items.forEach(function (entry) {
      var itemQuantity = quantity(entry, 1);
      var amount = unitAmount(entry);
      contents.push(buildContent(entry, itemQuantity));
      if (amount === null) {
        hasAllAmounts = false;
      } else {
        total += amount * itemQuantity;
      }
    });

    var data = { type: 'contents', contents: contents };
    if (hasAllAmounts && state.currency) {
      data.amount = total;
      data.currency = state.currency;
    }
    measure('items_added', data);
  }

  function addedItemsFromPayload(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.items)) return payload.items;
    return [payload];
  }

  function trackAddedItem(payload) {
    var items = addedItemsFromPayload(payload).filter(function (item) {
      return quantity(item, 0) > 0;
    });
    if (!items.length) return;

    items.forEach(function (item) {
      var key = itemKey(item);
      if (!key) return;
      var previous = state.cart[key] || snapshotItem(item);
      previous.quantity = (state.cart[key] ? state.cart[key].quantity : 0) + quantity(item, 1);
      state.cart[key] = previous;
    });
    emitItemsAdded(items);
  }

  function trackCartIncrease(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return;
    if (cartData.currency) state.currency = cartData.currency;

    var increases = [];
    var next = {};
    cartData.items.forEach(function (item) {
      var key = itemKey(item);
      if (!key) return;
      var current = snapshotItem(item);
      var previousQuantity = state.cart[key] ? state.cart[key].quantity : 0;
      var increase = current.quantity - previousQuantity;
      next[key] = current;
      if (increase > 0) {
        var increasedItem = snapshotItem(item);
        increasedItem.quantity = increase;
        increases.push(increasedItem);
      }
    });
    state.cart = next;
    emitItemsAdded(increases);
  }

  function initialiseCartTracking() {
    replaceCartSnapshot((config.cart && config.cart.items) || []);

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (!cartData) return;

      if (Array.isArray(cartData.items) && cartData.item_count !== undefined) {
        trackCartIncrease(cartData);
      } else if (event.source === 'product-form') {
        trackAddedItem(cartData);
      }
    });
  }

  function initialisePublicApi() {
    var api = window.mdnmdOpenAIAds = window.mdnmdOpenAIAds || {};
    api.pixelIds = pixelIds.slice();
    api.track = function (eventName, data, options) {
      return trackEvent(eventName, data, options);
    };
    api.trackForPixel = function (pixelId, eventName, data, options) {
      return trackEvent(eventName, data, options, pixelId);
    };
    api.trackAddedItem = trackAddedItem;
    api.trackLeadCreated = function (data, options) {
      return trackCustomerAction('lead_created', data, options);
    };
    api.trackRegistrationCompleted = function (data, options) {
      return trackCustomerAction('registration_completed', data, options);
    };
    api.trackAppointmentScheduled = function (data, options) {
      return trackCustomerAction('appointment_scheduled', data, options);
    };
    api.trackSubscriptionCreated = function (data, options) {
      return trackPlanEnrollment('subscription_created', data, options);
    };
    api.trackTrialStarted = function (data, options) {
      return trackPlanEnrollment('trial_started', data, options);
    };
    api.trackOrderCreated = function (data, options) {
      data = data || {};
      if (!data.type) data.type = 'contents';
      return trackEvent('order_created', data, options);
    };
    api.trackCustom = function (customEventName, data, options) {
      data = data || {};
      if (!data.type) data.type = 'custom';
      options = options || {};
      options.custom_event_name = customEventName;
      return trackEvent('custom', data, options);
    };
  }

  function currentCartContents() {
    return Object.keys(state.cart).map(function (key) {
      var item = state.cart[key];
      return buildContent(item, item.quantity);
    });
  }

  function trackCheckoutStarted() {
    if (state.checkoutTracked) return;
    state.checkoutTracked = true;

    var contents = currentCartContents();
    var data = { type: 'contents', contents: contents };
    var total = 0;
    var hasAllAmounts = contents.length > 0;
    contents.forEach(function (item) {
      if (item.amount === undefined) {
        hasAllAmounts = false;
      } else {
        total += item.amount * item.quantity;
      }
    });
    if (hasAllAmounts && state.currency) {
      data.amount = total;
      data.currency = state.currency;
    }
    measure('checkout_started', data);
  }

  function isCheckoutControl(control) {
    if (!control || control.disabled) return false;
    var name = (control.getAttribute('name') || '').toLowerCase();
    var href = control.getAttribute('href') || '';
    var formAction = control.getAttribute('formaction') || '';
    return name === 'checkout' || /\/checkout(?:[/?#]|$)/.test(href) || /\/checkout(?:[/?#]|$)/.test(formAction);
  }

  function initialiseCheckoutTracking() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      var control = target && typeof target.closest === 'function'
        ? target.closest('[name="checkout"], a[href*="/checkout"], button[formaction*="/checkout"]')
        : null;
      if (isCheckoutControl(control)) trackCheckoutStarted();
    }, true);

    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var action = event.target && event.target.action;
      if (isCheckoutControl(submitter) || /\/checkout(?:[/?#]|$)/.test(action || '')) {
        trackCheckoutStarted();
      }
    }, true);
  }

  initialisePublicApi();
  initialiseCartTracking();
  initialiseCheckoutTracking();
  initialiseConsent();
})();
